import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { m6_2Endpoints } from '../../../endpoints/m6-2';
import {
  IManualEntryPreferences,
  IUpsertManualPreferencesPayload,
  ManualEntryScopeType,
} from '../../../models/m6-2';

/**
 * Fetch preferenze input manuale con fallback chain team → user global (M6.2 B13).
 */
export function useManualEntryPreferences(
  scopeType: ManualEntryScopeType,
  scopeId: string | null,
) {
  return useQuery<IManualEntryPreferences | null>({
    queryKey: ['m6-2', 'manual-entry-preferences', scopeType, scopeId],
    queryFn: async () => {
      if (!scopeId) return null;
      const res = await m6_2Endpoints.getManualEntryPreferences(
        scopeType,
        scopeId,
      );
      return res.data;
    },
    enabled: !!scopeId,
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Upsert preferenze (incrementa useCount server-side).
 */
export function useUpsertManualEntryPreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: IUpsertManualPreferencesPayload) =>
      m6_2Endpoints.upsertManualEntryPreferences(payload),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({
        queryKey: [
          'm6-2',
          'manual-entry-preferences',
          vars.scopeType,
          vars.scopeId,
        ],
      });
    },
  });
}
